import React, {
    useContext,
    useEffect,
} from 'react'

import {EmbedContext} from 'components/EmbedContext'
import {useAppSelector} from 'hooks'
import {useRouting} from 'navigation/hooks'

export const EmbedHome = () => {
    const embed = useContext(EmbedContext)
    const {pushRoute} = useRouting()

    const user_channels = useAppSelector(({ninchat}) => ninchat.user_channels)

    useEffect(() => {
        const channels = Object.keys(user_channels)

        if (channels.length > 0 && embed?.scheduleAccessKey) {
            pushRoute({
                name: 'EmbedChannel',
                params: {channel_id: channels[0]},
            })
        } else if (embed?.variant === 'channel') {
            pushRoute({
                name: 'EmbedChannel',
                params: {channel_id: embed?.channelId || ''},
            })
        } else if (embed?.preAudienceQuestionnaire) {
            // show prequestionnaire
            pushRoute({name: 'EmbedQuestionnaire'})
        }
    }, [user_channels])

    return (
        <div>
            {/* EMPTY FOR NOW */}
        </div>
    )
}
